import React from "react"
import Link from "@mui/material/Link"
import Box from "@mui/material/Box"
import { keyframes } from "@emotion/react"
import { MENU_ITEMS_PROPS } from "../../../constants"

const slide = keyframes`
0%  { opacity: 0 }
100% { opacity: 1 }
`

const Menu = ({ isMenuVisible, itemVerticalSpace }) => {
  const styles = {
    linkStyle: {
      marginBottom: `${itemVerticalSpace}px`,
      color: "#fff",
      fontSize: "21px",
      cursor: "pointer",
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        fontFamily: "Josefin Sans",
      }}
    >
      {MENU_ITEMS_PROPS?.map((item, key) => {
        return (
          <Link
            key={key}
            onClick={item?.onClick}
            underline="none"
            sx={[
              styles.linkStyle,
              {
                opacity: "0",
                ...(isMenuVisible && {
                  animation: `${slide} 1s forwards`,
                  animationDelay: '1s',
                }),
              },
            ]}
          >
            {item?.label}
          </Link>
        )
      })}
    </Box>
  )
}

export default Menu
